import React, { type FC, type ReactElement } from "react";
import { FaChevronDown } from "react-icons/fa";

import { primaryRipple } from "@utilities/helper";
import { motion } from "framer-motion";

interface AccordionType {
  title: string;
  description: string;
  isExpanded: boolean;
  callbackOnClick: () => void;
}

const Accordion: FC<AccordionType> = ({
  title,
  description,
  isExpanded,
  callbackOnClick,
}): ReactElement => {
  return (
    <button
      ref={primaryRipple}
      onClick={callbackOnClick}
      className="focus:custom-primary-focus-ring mb-2 cursor-pointer overflow-hidden rounded-2xl border border-solid border-gray-300 bg-white px-7 py-4 shadow-lg transition duration-300 hover:bg-primary-100"
    >
      <div className="flex flex-row items-center justify-between gap-2">
        <h3 className="text-left text-base font-semibold sm:text-lg md:text-xl">
          {title}
        </h3>
        <motion.div
          initial={{ rotate: 0 }}
          animate={{
            rotate: isExpanded ? 180 : 0,
          }}
          transition={{ duration: 0.3 }}
        >
          <FaChevronDown className="text-gray-500" />
        </motion.div>
      </div>

      <motion.div
        initial={{ marginTop: "0rem", gridTemplateRows: "0fr" }}
        animate={{
          marginTop: isExpanded ? "0.5rem" : "0rem",
          gridTemplateRows: isExpanded ? "1fr" : "0fr",
        }}
        transition={{ duration: 0.3 }}
        className="grid overflow-hidden transition-[grid-template-rows] duration-300"
      >
        <motion.div
          initial={{ opacity: 0 }}
          animate={{
            opacity: isExpanded ? 1 : 0,
          }}
          transition={{ duration: 0.3 }}
          className="min-h-0 text-justify text-gray-700/90"
        >
          {description}
        </motion.div>
      </motion.div>
    </button>
  );
};

export default Accordion;
